import React, {useState,useEffect} from 'react';
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import {Tools} from './Tools';
import {Inc,Dataset,NewsSearchCondition,SortOption} from './Inc';
import Title from './Title';
import AppBank from './AppBank';

interface NewsListSearchProps {
    update(cond:NewsSearchCondition,page:number): void,
	bankKey:string,
	bank:AppBank,
}

const NewsListSearch = (props:NewsListSearchProps)=> {
    const classes = useStyles();
    const [states,setStates] = useState(Inc.defaultNewsSearchCondition());

    const update = ()=>{
		props.bank.set(props.bankKey,JSON.stringify(states));
        props.update(states,1);
    }
	const handleChange = (name: keyof NewsSearchCondition) => (event: React.ChangeEvent<HTMLInputElement>) => {
		setStates({ ...states, [name]: event.target.value });
	};
	const handleChangeSelect = (name: keyof NewsSearchCondition) => (event: SelectChangeEvent) => {
		setStates({ ...states, [name]: event.target.value });
    };
	const handleChangeOption = (name: keyof SortOption) => (event: SelectChangeEvent) => {
        let option = states.option;
        option[name] = event.target.value;
		setStates({ ...states, "option": option});
    };
	const handleChangeCheckboxes = (name: keyof NewsSearchCondition,index:number) => (event: React.ChangeEvent<HTMLInputElement>) => {
		let boolList:boolean[] = [];
		let idList:string[] = [];
		let blName:string = "";
		let datas:Dataset[] = [];
		if( name==="status_ids" ){
			boolList = states.status_bls;
			blName = "status_bls";
			datas = Inc.newsStatus;
        }
		if( blName!=="" ){
			if( event.target.checked ){
				boolList[index] = true;
			} else {
				boolList[index] = false;
			}
			for( let i=0 ; i<boolList.length ; i++ ){
				if( boolList[i] ){
					idList.push( datas[i].id );
				}
			}
			setStates({ ...states, [blName]: boolList, [name]: idList });
		}
	};
	const resetCondition = ()=>{
		setStates(Inc.defaultNewsSearchCondition());
    }
	const checkboxes = (id:keyof NewsSearchCondition,list:Dataset[])=>{
		const tmp = list.map( (data:Dataset,index:number)=>{
			const key = id+index;
			let v:boolean = false;
			if( id==="status_ids" ){
                v = states.status_bls[index];
			}
			return (
				<FormControlLabel
			    	key={key}
					control={
					<Checkbox
						checked={v}
						onChange={handleChangeCheckboxes(id,index)}
						value={data.id}
						color="primary"
						className={classes.checkbox}
					/>
					}
					label={data.label}
				/>
			);
		});
		return (
			<div className={classes.checkboxes}>
				{tmp}
			</div>
		)
    };
    
    useEffect( ()=>{
		if( props.bank.has(props.bankKey) ){
			//console.log("load");
			const cond = JSON.parse(props.bank.get(props.bankKey));
			setStates(cond);
			props.update(cond,1);
		} else {
			props.update(states,1);
		}
    },[])
    
    const years = Tools.getSelectYears();
    const months = Tools.getSelectMonths();
    const orders:Dataset[] = [
        {
            id:"news_date",
            label:"公開日",
        },
        {
            id:"news_name",
            label:"タイトル",
        },
        {
            id:"end_date",
            label:"終了日",
        },
        {
            id:"regist_time",
            label:"登録日時",
        },
        {
            id:"update_time",
            label:"更新日時",
        },
    ]
    const targets:Dataset[] = [
        {
            id:"news_date",
            label:"公開日",
        },
        {
            id:"end_date",
            label:"終了日",
        },
        {
            id:"regist_time",
            label:"登録日時",
        },
        {
            id:"update_time",
            label:"更新日時",
        },
    ]

    //console.log("stock::list::search");
	
	return (
		<div id="stock_list_search">
            
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Title text="検索条件" size={2}/>
                </Grid>
                <Grid item xs={6}>
                    <div className={classes.searchButtons}>
                        <Button variant="outlined" color="primary" onClick={update}><SearchIcon/>検索</Button>
                    </div>
                </Grid>
                <Grid item xs={12} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>タイトル</FormLabel>
                        <TextField
                            className={classes.input}
                            inputProps={{
                                'aria-label': 'Description',
                            }}
                            margin="none"
                            value={states.news_name}
							variant='standard'
                            onChange={handleChange("news_name")}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>本文</FormLabel>
                        <TextField
                            className={classes.input}
                            inputProps={{
                                'aria-label': 'Description',
                            }}
                            margin="none"
                            value={states.news_body}
							variant='standard'
                            onChange={handleChange("news_body")}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>状態</FormLabel>
                        <FormGroup>
                            {checkboxes("status_ids",Inc.newsStatus)}
                        </FormGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <FormGroup row>
                        <FormControl className={classes.formControl} >
                            <FormLabel component="label" className={classes.formLabel}>手続き年月</FormLabel>
                            <Select
                                value={states.date_target}
                                onChange={handleChangeSelect('date_target')}
                                inputProps={{
                                    name: 'target',
                                    id: 'target-simple',
                                }}
                                margin="none"
								variant='standard'
                                className={classes.select}
								style={{width:'6em'}}
                            >
                                <MenuItem key="target0" value="">　</MenuItem>
                                {targets.map((option:Dataset,index:number) => {
                                    const key = "target"+index;
                                    return (
                                        <MenuItem key={key} value={option.id}>
                                            {option.label}が
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl} >
                            <FormLabel component="label" className={classes.formLabel}>　</FormLabel>
                            
                            <Select
                                value={states.date_year}
                                onChange={handleChangeSelect('date_year')}
                                inputProps={{
                                    name: 'year',
                                    id: 'year-simple',
                                }}
                                margin="none"
								variant='standard'
                                className={classes.select}
								style={{width:'5em'}}
                            >
                                <MenuItem key="year0" value="">　</MenuItem>
                                {years.map((option:Dataset,index:number) => {
                                    const key = "year"+index;
                                    return (
                                        <MenuItem key={key} value={option.id}>
                                            {option.label}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>

                        <FormControl className={classes.formControl}>
                            <FormLabel component="label" className={classes.formLabel}>　</FormLabel>
                            <Select
                                value={states.date_month}
                                onChange={handleChangeSelect('date_month')}
                                inputProps={{
                                    name: 'month',
                                    id: 'month-simple',
                                }}
                                margin="none"
								variant='standard'
                                className={classes.select}
								style={{width:'4em'}}
                            >
                                <MenuItem key="month0" value="">　</MenuItem>
                                {months.map((option:Dataset,index:number) => {
                                    const key = "month"+index;
                                    return (
                                        <MenuItem key={key} value={option.id}>
                                            {option.label}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </FormGroup>
                </Grid>

                <Grid item xs={4} md={6} lg={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示基準</FormLabel>
                        
                        <Select
                            value={states.option.order}
                            onChange={handleChangeOption('order')}
                            inputProps={{
                                name: 'order',
                                id: 'order-simple',
                            }}
                            margin="none"
							variant='standard'
                            className={classes.select}
                        >
                            {orders.map((option:Dataset,index:number) => {
                                const key = "order"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} md={6} lg={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示順</FormLabel>
                        
                        <Select
                            value={states.option.sort}
                            onChange={handleChangeOption('sort')}
                            inputProps={{
                                name: 'sort',
                                id: 'sort-simple',
                            }}
                            margin="none"
							variant='standard'
                            className={classes.select}
                        >
                            {Inc.sorts.map((option:Dataset,index:number) => {
                                const key = "sort"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} md={12} lg={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示件数</FormLabel>
                        
                        <Select
                            value={states.option.per_page}
                            onChange={handleChangeOption('per_page')}
                            inputProps={{
                                name: 'per_news',
                                id: 'per_news-simple',
                            }}
                            margin="none"
							variant='standard'
                            className={classes.select}
                        >
                            {Inc.perPages.map((option:Dataset,index:number) => {
                                const key = "per_news"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>

            </Grid>
            <Button variant="outlined" fullWidth={true} className={classes.buttonReset} onClick={resetCondition}><DeleteIcon/>検索条件のリセット</Button>
		</div>
	);
}

export default NewsListSearch;
